import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box, Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";

import { OrderStatusEnum } from "@/interfaces/domain/Order";

type OrderStatusBadgeProps = {
  orderStatus: OrderStatusEnum;
};

const OrderStatusTimeline = ({ orderStatus }: OrderStatusBadgeProps) => {
  const statusNames = {
    [OrderStatusEnum.CREATED]: "Criado",
    [OrderStatusEnum.RECEIVED]: "Recebido",
    [OrderStatusEnum.IN_SEPARATION]: "Em separação",
    [OrderStatusEnum.SEPARATED]: "Separado",
    [OrderStatusEnum.RELEASED]: "Liberado",
    [OrderStatusEnum.IN_DELIVERY]: "Em entrega",
    [OrderStatusEnum.ARRIVED]: "Chegou",
    [OrderStatusEnum.DELIVERED]: "Entregue",
  };

  const renderStatusItem = (status: OrderStatusEnum, active: boolean, isLast: boolean) => (
    <HStack key={status} h="60px">
      <VStack alignItems="center">
        <Box bgColor="white.50" rounded="full">
          <Icon
            as={
              <MaterialCommunityIcons
                name={active ? "check-circle" : "checkbox-blank-circle-outline"}
              />
            }
            size="lg"
            color="primary.600"
          />
        </Box>
        {!isLast && (
          <Box flexGrow={1}>
            <Divider orientation="vertical" borderWidth="1" borderColor="primary.600" />
          </Box>
        )}
      </VStack>
      <Text mx="2" fontSize="md" color="primary.600">
        {statusNames[status]}
      </Text>
    </HStack>
  );

  return (
    <VStack flexWrap="wrap" p="2">
      {Object.keys(statusNames).map((key, index) => {
        const foundIndex = Object.keys(statusNames).findIndex((k) => k === orderStatus);
        const active = index <= foundIndex || foundIndex === -1;
        const isLast = index === Object.keys(statusNames).length - 1;
        return renderStatusItem(key as OrderStatusEnum, active, isLast);
      })}
    </VStack>
  );
};

export default OrderStatusTimeline;
